import { addDefaultOptions } from '@arpav/config/Blocks/ListingOptions';

export const addPartnerTemplateOptions = (schema, formData, intl, position = 0) => {
  return addDefaultOptions(schema, formData, intl, position);
};
